<template>

    <div class="textarea-container">
        <textarea class="textarea" :placeholder="placeholder" :class="classes" :rows="rows" v-model="val" />
        <div v-if="max && val" class="textarea-footer">
            <span :class="{ 'text-danger': remaining < 0 }">{{ remaining | numeral }} {{ $t('labels.remaining').toLowerCase() }}</span>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .textarea-container {
        position: relative;
    }

    .textarea-footer {
        @include font-regular(12px);
        bottom: 0;
        color: $color-muted;
        margin-top: 10px;
        padding: 0;
        right: 0;
        user-select: none;
        z-index: 1;
    }

    .textarea {
        @include font-regular(14px);
        appearance: none;
        background: $color-white;
        border: 1px solid $color-rule;
        border-radius: 5px;
        box-sizing: border-box;
        color: $color-text;
        display: block;
        line-height: 1.6em;
        outline: none;
        padding: 15px;
        resize: none;
        transition: border-color .3s;
        width: 100%;
        &.resize {
            resize: both;
        }
        &:hover, &:focus {
            border-color: $color-text;
            color: $color-text;
        }
        &:disabled {
            background: $color-bg;
            border-color: $color-rule;
        }
    }

</style>

<script>

export default {

    props: {
        model: {
            required: true,
        },
        max: {
            type: Number,
        },
        rows: {
            type: Number,
            default: 5,
        },
        resize: {
            type: Boolean,
            default: true,
        },
        placeholder: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            val: this.model,
        }
    },

    watch: {

        model(val) {
            this.val = val;
        },

        val(val) {
            this.$emit('input', val);
        },

    },

    computed: {

        classes() {
            return {
                resize: this.resize,
            }
        },

        remaining() {
            return this.max && this.val ? this.max - this.val.length : this.max;
        },

    }

}

</script>
